(ns teamoesterreich.admin-mode.event.detail.event-user-table
  (:require ["react-virtualized" :as rv]
            [clojure.string]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [reagent.core :as r]
            [teamoesterreich.admin-mode.actions :as a]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.util.date :as h-date]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.selection.selection-table :as table]
            [teamoesterreich.admin-mode.modal.toe-info :as toe-modal]
            [teamoesterreich.admin-mode.data.eventMember :as d-eventMember]
            [teamoesterreich.admin-mode.modal.send-message-modal :as send-message-modal]
            [teamoesterreich.admin-mode.data.event :as d-event]
            [teamoesterreich.admin-mode.data.user :as d-user]
            [teamoesterreich.admin-mode.modal.enter-amount-modal :as enter-amount-modal]
            [teamoesterreich.admin-mode.modal.are-you-sure-modal :as are-you-sure-modal]
            [teamoesterreich.util.helper :as h]
            [reagent-material-ui.icons.email :refer [email]]
            [reagent-material-ui.icons.add :refer [add]]
            [reagent-material-ui.icons.check-box :refer [check-box]]
            [reagent-material-ui.icons.check-box-outline-blank :refer [check-box-outline-blank]]
            [reagent-material-ui.icons.close :refer [close]]
            [reagent-material-ui.icons.cloud-download :refer [cloud-download]]
            [reagent-material-ui.icons.info :refer [info]]
                   ;;(h/event-value e)
            ))


(def responseState-map {"accepted" "zugesagt" "declined" "abgelehnt" "invalid" "ungültig" "unknown" "-"})
(def missionState-map {"participated" "teilgenommen" "absent" "abwesend" "invalid" "ungültig" "unknown" "-"})


(defn count-true [map_]
  (count (filter second map_)))


(defn info-cell-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    (r/as-element
      [mui/icon-button {:label   "bearbeiten"
                        :onClick (fn []
                                   (log/debug "bearbeiten geklickt " cell-data)
                                   (swap! vstate/app-state assoc-in [:toe-map :activeUserPopup] cell-data))
                        } [info {:fontSize "small"}]])))

(defn date-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)
        ;l-date (date-h/parse-local-date cell-data)
        ]
    ;(js/console.log l-date)
    (r/as-element
      [:span (if (> (count cell-data) 10)
               (str (subs cell-data 6 8) "." (subs cell-data 4 6) "." (subs cell-data 0 4))
               "-")])))
(defn last-contact-renderer [js-parm]
  (let [{row-data "rowData"} (js->clj js-parm)
        {last-contact "last-contact" last-app-contact "last-app-contact"} row-data]
    (r/as-element [:div
                   [:span (h-date/googDate->ger! last-contact)]
                   [:br]
                   (when last-app-contact [:span {:style {:color "blue"}} (h-date/googDate->ger! last-app-contact) " (App)"])])))
(defn date-time-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    ;(js/console.log l-date)
    (if (> (count cell-data) 10)
      (r/as-element [:span (str (subs cell-data 6 8) "." (subs cell-data 4 6) "." (subs cell-data 0 4)) [:br] (str (subs cell-data 9 11) ":" (subs cell-data 11 13))])
      (r/as-element [:span "-"]))))



(defn response-state-cell-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    (r/as-element
      [:span (or (get responseState-map (str cell-data)) "-")])))


(defn additional-cell-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    (r/as-element
      [:pre
       "" (reduce (fn [c s] (str c "- " (get s "eventSlot-name") "\n")) "" cell-data)
       ])))

(defn state-cell-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    (r/as-element
      [:span (or (get missionState-map (str cell-data)) "-")])))

(defn select-renderer [!st ?ro]
  (fn [js-parm]
    (let [{cell-data "cellData"} (js->clj js-parm)]
      (r/as-element
        [mui/checkbox
         {:onChange (fn [_ val] (swap! !st assoc-in [:selected cell-data] val))
          :disabled ?ro
          :checked  (or (get-in @!st [:selected cell-data]) false)
          }
         ]))))

(defn inside-table [!st !rows {:keys [ro? show-mission-state? show-response-state? show-alarm-answer?]}]
  (fn [m]
    (let [width (aget m "width")
          height (aget m "height")
          !sort (r/cursor !st [:sort])
          !reverse (r/cursor !st [:reverse])
          ]
      (r/as-element
        [:> rv/Table
         {:headerHeight    50
          :height          (- height 250)
          :rowCount        (count @!rows)
          :rowGetter       (fn [i]
                             ;(println (str "rowGet " (aget i "index")))
                             (clj->js (nth @!rows (aget i "index"))))
          :rowClassName    (fn [i] (when (odd? (aget i "index")) "table-odd"))
          :sort            (fn [s] (swap! !st assoc :sort (aget s "sortBy") :reverse (= "DESC" (aget s "sortDirection"))))
          :sortBy          @!sort
          :sortDirection   (if @!reverse "DESC" "ASC")
          :rowHeight       45
          :width           width
          :headerClassName "headerColumn"
          :className       "EventUserList"}
         (log/debug "rerender " m " @!sort " @!sort " @!reverse " @!reverse " cnt:" (count @!rows))

         [:> rv/Column
          {:label        (r/as-element [mui/checkbox {:disabled true}])
           :dataKey      (name :user-tomId)
           :className    "bordered exampleColumn"
           :cellRenderer (select-renderer !st ro?)
           :width        70} [:a {:href ""}]]

         [:> rv/Column
          {:label     "TomId"
           :dataKey   "user-tomId"
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden"}
           :width     70}]
         [:> rv/Column
          {:label     "Vorname"
           :dataKey   "user-firstName"
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden"}
           :width     170}]
         [:> rv/Column
          {:label     "Nachname"
           :dataKey   "user-lastName"
           :className "bordered exampleColumn"
           :width     170}]
         [:> rv/Column
          {:label        "Geburtstag"
           :dataKey      "user-birthday"
           :className    "bordered exampleColumn"
           :cellRenderer date-renderer
           :width        170}]
         [:> rv/Column
          {:label     "Email"
           :dataKey   "user-email"
           :className "bordered exampleColumn"
           :width     170}]
         [:> rv/Column
          {:label     "Handy"
           :dataKey   "user-phoneNumber"
           :className "bordered exampleColumn"
           :width     170}]

         [:> rv/Column
          {:label        (r/as-element [:span "Letzter" [:br] "Kontakt"])
           :dataKey      "last-contact"
           :cellRenderer last-contact-renderer
           :className    "bordered exampleColumn"
           :width        100}]


         [:> rv/Column
          {:label        (r/as-element [info])
           :dataKey      "user-tomId"
           :className    "bordered exampleColumn"
           :cellRenderer info-cell-renderer
           :width        70}]

         (when show-alarm-answer?
           [:> rv/Column
            {:label     (r/as-element [:span "SMS" [:br] "Antwort"])
             :dataKey   "response-sms-text"
             :className "bordered exampleColumn"
             :width     120}])
         (when show-alarm-answer?
           [:> rv/Column
            {:label        (r/as-element [:span "Antwort" [:br] ""])
             :dataKey      "response-time"
             :className    "bordered exampleColumn"
             :cellRenderer date-time-renderer
             :width        100}])
         (when (or show-mission-state? show-alarm-answer?)
           [:> rv/Column
            {:label        (r/as-element [:span "Termine" [:br] ""])
             :dataKey      "response-slots"
             :className    "bordered exampleColumn"
             :cellRenderer additional-cell-renderer
             :width        100}])


         (when show-response-state?
           [:> rv/Column
            {:label        (r/as-element [:span "Antwort" [:br] "Status"])
             :dataKey      "response-state"
             :className    "bordered exampleColumn"
             :cellRenderer response-state-cell-renderer
             :width        140}])

         (when show-mission-state?
           [:> rv/Column
            {:label        (r/as-element [:span "Einsatz" [:br] "Status"])
             :dataKey      "mission-state"
             :className    "bordered exampleColumn"
             :cellRenderer state-cell-renderer
             :width        140}])

         ]))))





(defn filter-fn [rows search]
  (filter (fn [e]
            (re-find
              (re-pattern (reduce (fn [c e] (str c "(?=.*" e ")")) "(?i)^" (clojure.string/split search " ")))
              (str (:user-tomId e) "#" (:user-firstName e) "#" (:user-lastName e) "#" (:user-email e) "#" (:user-phoneNumber e))))
          rows))

(defn get-sort-filter-rows [rows sort_ reverse_ filter_]
  (js/console.log "get-sort-filter-rows = " rows)
  (let [rows (if rows (mapv (fn [[k v]] (assoc v :index k)) rows) [])
        rows (filter-fn rows filter_)
        rows (sort-by (keyword (if sort_ sort_ :user-lastName)) rows)
        rows (if reverse_ (reverse rows) rows)]
    (println "get-sort-filter-rows RES:" (count rows))
    rows))




(defn table-column [!st rows]
  (let [
        rows (get-sort-filter-rows rows (:sort @!st) (:reverse @!st) (:search @!st))
        cnt-rows (count rows)]

    (if (> cnt-rows 0)
      [(table/table !st rows)]
      [:h3 "Keine Ergebnisse gefunden!"])
    ))


(defn get-table [!st !rows table-set]
  (fn [] [:> rv/AutoSizer
          {:style       {:height "100%" :minHeight "400px"}
           :x-data-sort (str "rerender !st" @!st)}
          (inside-table !st !rows table-set)]))


(defn selected-actions [!event !st {:keys [allow-change-slot? allow-unknown? allow-accepted? allow-rejected? allow-participated? allow-absent? allow-standby? allow-alarm? allow-force-alarm? allow-remove?]} rows]
  (let [event-uuid (:crowdtaskerEvent-uuid @!event)
        !show-force-alarm (r/cursor !st [:show-force-alarm-multi])
        !show-add-selected (r/cursor !st [:add-selected])
        !show-alarm (r/cursor !st [:show-alarm-multi])
        !show-add-slot (r/cursor !st [:show-add-slot])
        !show-remove-slot (r/cursor !st [:show-remove-slot])
        !show-select-first (r/cursor !st [:show-select-first])
        !show-accepted (r/cursor !st [:show-accepted-multi])
        !show-declined (r/cursor !st [:show-declined-multi])
        !show-accepted-silent (r/cursor !st [:show-accepted-multi-silent])
        !show-declined-silent (r/cursor !st [:show-declined-multi-silent])
        !show-unknown (r/cursor !st [:show-unknown-multi])
        !show-absent (r/cursor !st [:show-absent-multi])
        !show-participated (r/cursor !st [:show-participated-multi])
        !show-standby (r/cursor !st [:show-standby-multi])
        !show-remove (r/cursor !st [:show-remove-multi])
        !st-selected (r/cursor !st [:selected])
        !st-selection-action (r/cursor !st [:selected-action])
        !st-selection-slot (r/cursor !st [:selected-slot])
        !show-message-sent (r/cursor !st [:activeMessageSent])
        !show-send-mail-multiple (r/cursor !st [:activeSendMailMultiple])
        update-fn (fn [] (reset! !st-selected {}) (d-event/event-update))
        select-first-fn (fn [& [max]] (reset! !st-selected (reduce (fn [c {tomId :user-tomId}] (log/debug "select all + " tomId) (assoc c tomId true)) @!st-selected (take (or max 1000000) rows))))
        ]
    [:div
     [enter-amount-modal/modal !show-select-first (str "Ersten X Personen auswählen. Anzahl eingeben bitte:") "Auswählen"
      (fn [amount] (select-first-fn amount))]

     [are-you-sure-modal/are-you-sure-modal !show-alarm (str "Willst du diese ausgewählten " (count-true @!st-selected) " Teilnehmer wirklich per Push/SMS anfragen? Bereits angefragte werden ignoriert.") "anfragen"
      (fn [] (d-eventMember/>members-set event-uuid @!st-selected "alarm" @!st-selection-slot #(update-fn)))]
     [are-you-sure-modal/are-you-sure-modal !show-force-alarm (str "Willst du diese ausgewählten " (count-true @!st-selected) " Teilnehmer wirklich per Push/SMS erneut anfragen? Bereits alarmierte werden nochmals angefragt.") "anfragen"
      (fn [] (d-eventMember/>members-set event-uuid @!st-selected "force-alarm" @!st-selection-slot #(update-fn)))]

     [are-you-sure-modal/are-you-sure-modal !show-remove (str "Willst du diese ausgewählten " (count-true @!st-selected) " Teilnehmer wirklich entfernen?") "Entfernen"
      (fn [] (d-eventMember/>members-set event-uuid @!st-selected "delete" @!st-selection-slot #(update-fn)))]
     [are-you-sure-modal/are-you-sure-modal !show-unknown (str "Willst du diese ausgewählten " (count-true @!st-selected) " Teilnehmer wirklich auf `Angefragt` setzen?") "Ok"
      (fn [] (d-eventMember/>members-set event-uuid @!st-selected "alarmed" @!st-selection-slot #(update-fn)))]
     [are-you-sure-modal/are-you-sure-modal !show-accepted (str "Willst du diese ausgewählten " (count-true @!st-selected) " Teilnehmer wirklich auf `Zugesagt` setzen?") "Ok"
      (fn [] (d-eventMember/>members-set event-uuid @!st-selected "accepted" @!st-selection-slot #(update-fn)))]
     [are-you-sure-modal/are-you-sure-modal !show-declined (str "Willst du diese ausgewählten " (count-true @!st-selected) " Teilnehmer wirklich auf `Abgesagt` setzen?") "Ok"
      (fn [] (d-eventMember/>members-set event-uuid @!st-selected "declined" @!st-selection-slot #(update-fn)))]
     [are-you-sure-modal/are-you-sure-modal !show-accepted-silent (str "Willst du diese ausgewählten " (count-true @!st-selected) " Teilnehmer wirklich auf `Zugesagt` ohne Mail/SMS setzen?") "Ok"
      (fn [] (d-eventMember/>members-set event-uuid @!st-selected "accepted-silent" @!st-selection-slot #(update-fn)))]
     [are-you-sure-modal/are-you-sure-modal !show-declined-silent (str "Willst du diese ausgewählten " (count-true @!st-selected) " Teilnehmer wirklich auf `Abgesagt` ohne Mail/SMS setzen?") "Ok"
      (fn [] (d-eventMember/>members-set event-uuid @!st-selected "declined-silent" @!st-selection-slot #(update-fn)))]
     [are-you-sure-modal/are-you-sure-modal !show-standby (str "Willst du diese ausgewählten " (count-true @!st-selected) " Teilnehmer wirklich auf `Reserve` setzen?") "Ok"
      (fn [] (d-eventMember/>members-set event-uuid @!st-selected "standby" @!st-selection-slot #(update-fn)))]
     [are-you-sure-modal/are-you-sure-modal !show-absent (str "Willst du diese ausgewählten " (count-true @!st-selected) " Teilnehmer wirklich auf `Nicht gekommen` setzen?") "Ok"
      (fn [] (d-eventMember/>members-set event-uuid @!st-selected "absent" @!st-selection-slot #(update-fn)))]
     [are-you-sure-modal/are-you-sure-modal !show-participated (str "Willst du diese ausgewählten " (count-true @!st-selected) " Teilnehmer  wirklich auf `Im Einsatz` setzen?") "Ok"
      (fn [] (d-eventMember/>members-set event-uuid @!st-selected "participated" @!st-selection-slot #(update-fn)))]
     [are-you-sure-modal/are-you-sure-modal !show-add-selected (str "Willst du diese ausgewählten " (count-true @!st-selected) " Teilnehmer in die Auswahl übernehmen?") "übernehmen"
      (fn [] (a/add-to-selection (mapv first @!st-selected)))]
     [(send-message-modal/email-template-modal !show-send-mail-multiple "event" (str "Email erstellen und an " (when @!show-send-mail-multiple (count @!show-send-mail-multiple)) " Personen senden:") "senden"
                                               (fn [subject email from] (d-user/email-to-tomIds (mapv first @!show-send-mail-multiple) subject email from #(reset! !show-message-sent true)))
                                               nil
                                               (fn [subject email from] (d-user/email-to-tomIds (mapv first @!show-send-mail-multiple) subject email from #(reset! !show-message-sent true) :self))
                                               )]
     [are-you-sure-modal/are-you-sure-modal !show-add-slot (str "Willst du diese ausgewählten " (count-true @!st-selected)
                                                                " Teilnehmer  wirklich auf Termin `" (:eventSlot-name (first (filter #(= (:eventSlot-uuid %) @!st-selection-slot) (:crowdtaskerEvent-slot @!event)))) "` buchen?")
      "Ok"
      (fn [] (d-eventMember/>members-set event-uuid @!st-selected "add-slot" @!st-selection-slot #(update-fn)))]
     [are-you-sure-modal/are-you-sure-modal !show-remove-slot (str "Willst du diese ausgewählten " (count-true @!st-selected)
                                                                   " Teilnehmer  wirklich vom Termin `" (:eventSlot-name (first (filter #(= (:eventSlot-uuid %) @!st-selection-slot) (:crowdtaskerEvent-slot @!event)))) "` entfernen?")
      "Ok"
      (fn [] (d-eventMember/>members-set event-uuid @!st-selected "remove-slot" @!st-selection-slot #(update-fn)))]

     [mui/icon-button {:title   "Alle abwählen"
                       :onClick #(swap! !st assoc :selected {})
                       } [check-box-outline-blank {:fontSize "small"}]]
     [mui/icon-button {:title   "Alle wählen"
                       :onClick #(select-first-fn)
                       } [check-box {:fontSize "small"}]]


     [mui/icon-button {:title   "Ersten X wählen"
                       :style   {:marginRight "15px"}
                       :onClick #(reset! !show-select-first true)
                       } [add {:fontSize "small"}]]
     [mui/select
      {:style        {:width "300px"}
       :defaultValue "-"
       :onChange     (fn [e]
                       (let [[action uuid] (clojure.string/split (h/event-value e) #"#")]
                         (log/debug " st-selection-action" action uuid)
                         (reset! !st-selection-action action)
                         (reset! !st-selection-slot (str uuid))))
       }
      [mui/menu-item {:value "-"} (str (count-true @!st-selected) " Auswahl")]
      (when allow-alarm? [mui/menu-item {:value "alarm"} "Jetzt anfragen"])
      (when allow-force-alarm? [mui/menu-item {:value "force-alarm"} "Jetzt (erneut) anfragen!"])
      (when allow-unknown? [mui/menu-item {:value "unknown"} "-> `Angefragt`"])
      (when allow-accepted? [mui/menu-item {:value "accepted"} "-> `Ja`"])
      (when allow-rejected? [mui/menu-item {:value "declined"} "-> `Nein`"])
      (when allow-accepted? [mui/menu-item {:value "accepted-silent"} "-> `Ja` ohne Mail/SMS"])
      (when allow-rejected? [mui/menu-item {:value "declined-silent"} "-> `Nein` ohne Mail/SMS"])

      (remove nil? (for [slot (sort-by :eventSlot-name (filter #(not (false? (:eventSlot-active %))) (:crowdtaskerEvent-slot @!event)))]
                     (when allow-change-slot?
                       ^{:key (str "slot-select-" (:eventSlot-uuid slot))}
                       [mui/menu-item {:value (str "add-slot#" (:eventSlot-uuid slot))} (str "-> Termin setzen: `" (:eventSlot-name slot) "`")]
                       )))
      (remove nil? (for [slot (sort-by :eventSlot-name (filter #(not (false? (:eventSlot-active %))) (:crowdtaskerEvent-slot @!event)))]
                     (when allow-change-slot?
                       ^{:key (str "slot-select-" (:eventSlot-uuid slot))}
                       [mui/menu-item {:value (str "remove-slot#" (:eventSlot-uuid slot))} (str "-> Termin entfernen: `" (:eventSlot-name slot) "`")]
                       )))

      (when allow-participated? [mui/menu-item {:value "participated"} "-> `im Einsatz`"])
      (when allow-absent? [mui/menu-item {:value "absent"} "-> `Nicht erschienen`"])
      (when allow-standby? [mui/menu-item {:value "standby"} "-> `Reserve`"])
      (when allow-remove? [mui/menu-item {:value "remove"} "-> Entfernen"])
      [mui/menu-item {:value "mailTo"} [email {:style {:marginRight "4px"}}] "  `Email senden`"]
      [mui/menu-item {:value "select"} "`In Auswahl übernehmen`"]
      ]
     [mui/button {:disabled (if (or (nil? @!st-selection-action) (empty? @!st-selected) (= @!st-selection-action "-")) true false)
                  :onClick  (fn []
                              (log/debug "übernehmen clicked " @!st-selection-action @!st-selected)
                              (case @!st-selection-action
                                "alarm" (reset! !show-alarm true)
                                "force-alarm" (reset! !show-force-alarm true)

                                "accepted" (reset! !show-accepted true)
                                "declined" (reset! !show-declined true)
                                "accepted-silent" (reset! !show-accepted-silent true)
                                "declined-silent" (reset! !show-declined-silent true)
                                "unknown" (reset! !show-unknown true)
                                "remove" (reset! !show-remove true)

                                "absent" (reset! !show-absent true)
                                "standby" (reset! !show-standby true)
                                "participated" (reset! !show-participated true)
                                "add-slot" (reset! !show-add-slot true)
                                "remove-slot" (reset! !show-remove-slot true)

                                "mailTo" (reset! !show-send-mail-multiple @!st-selected)
                                "select" (reset! !show-add-selected @!st-selected)
                                :else nil))
                  } "übernehmen"]
     ]
    ))

(defn get-it [member response-filter missionState-filter {:keys [ro?] :as table-set}]
  (let [!st (r/atom {:sort :user-lastName :reverse true :search "" :show-delete false :manipulate-tomId nil :show-mail false})
        !event (r/cursor vstate/app-state [:selected-event])
        !rows (r/atom [])
        user (into {} (map (fn [m] [(:crowdtaskerEventMember-uuid m)
                                    (assoc (:crowdtaskerEventMember-user m)
                                      :last-contact (reduce (fn [c dev] (let [lc (h-date/parse-service-date! (:device-lastContact dev))]
                                                                          (js/console.log "data last contact " lc)
                                                                          (if (and lc
                                                                                   (or (nil? c) (h-date/date>? lc c)))
                                                                            lc
                                                                            c)))
                                                            nil (get-in m [:crowdtaskerEventMember-user :device]))
                                      :last-app-contact (reduce (fn [c dev] (let [lc (h-date/parse-service-date! (:device-lastContact dev))]
                                                                              (js/console.log "data last contact " lc)
                                                                              (if (and lc
                                                                                       (or (nil? c) (h-date/date>? lc c)))
                                                                                lc
                                                                                c)))
                                                                nil (filter (fn [dev] (not= (:device-deviceId dev) "browser")) (get-in m [:crowdtaskerEventMember-user :device])))
                                      :member-uuid (:crowdtaskerEventMember-uuid m)
                                      :response (:crowdtaskerEventMember-responseState m)
                                      :response-sms-text (:crowdtaskerEventMember-responseText m)
                                      :response-slots (:crowdtaskerEventMember-slots m)
                                      :response-time (:crowdtaskerEventMember-responseTime m)
                                      :mission (:crowdtaskerEventMember-missionState m)
                                      )])
                           (filter (fn [e]
                                     (log/debug "filter " e "-" (:crowdtaskerEventMember-responseState e) " - " (:crowdtaskerEventMember-missionState e))
                                     (and
                                       (if response-filter (= response-filter
                                                              (or (:crowdtaskerEventMember-responseState e)
                                                                  (if (:crowdtaskerEventMember-alarmedType e) "alarmed" "undefined")))
                                                           true)
                                       (if missionState-filter (= (or (:crowdtaskerEventMember-missionState e) "undefined") missionState-filter) true)
                                       )) member)))
        ]
    (fn []
      (let [!map-userPopup (r/cursor vstate/app-state [:toe-map :activeUserPopup])
            !sort (r/cursor !st [:sort])
            !reverse (r/cursor !st [:reverse])
            !search (r/cursor !st [:search])
            !waiting? (r/cursor !st [:waiting])
            _ (reset! !rows (get-sort-filter-rows user @!sort @!reverse @!search))
            ]
        (log/debug "Event ROWS !!!!!!!!!!!!!!!!!!!!!!" (count @!rows))
        [mui/grid
         {:container  true
          :direction  "row"
          :alignItems "stretch"
          :justify    "flex-start"
          :style      {:height "calc(100% - 64px)" :minHeight "600px"}
          }

         [toe-modal/get-modal !map-userPopup]
         [mui/grid
          {:item  true
           :md    6
           :xs    6
           :style {:textAlign "left"}}
          (when-not ro?
            [selected-actions !event !st table-set @!rows])
          ]

         [mui/grid
          {:item  true
           :md    3
           :xs    3
           :style {:textAlign "left"}}
          [mui/text-field
           {:default-value (str @!search)
            :placeholder   "Suche in Liste ..."
            :style         {:width "250px" :display "inline-block"}
            :onChange      (h/wait-do !waiting? #(reset! !search %))
            :multiline     false}]
          (log/debug "Search " @!search)
          (when false                                       ; (> (count @!search) 0)
            [mui/button {:variant   "outlined"
                         :startIcon (r/as-element [close])
                         :onClick   (h/wait-do !waiting? (fn [_] (reset! !search "")))
                         :style     {:margin-left "5px" :margin-right "25px"}} ""])
          ]
         [mui/grid
          {:item  true
           :md    3
           :xs    3
           :style {:textAlign "right"}}
          [mui/button {:variant   "outlined"
                       :startIcon (r/as-element [cloud-download])
                       :onClick   #(d-eventMember/open-csv (:crowdtaskerEvent-uuid @!event) response-filter missionState-filter)

                       } "Csv Export"]
          ]

         [mui/grid
          {:item  true
           :lg    12
           :xs    12
           :style {:textAlign "left"}}

          [get-table !st !rows table-set]
          ]

         ]
        )
      )))

























